import React from 'react';
import { motion } from 'framer-motion';
import { MyCommitment } from '../../data/data';

interface MyCommitmentSectionProps {
  data: MyCommitment;
}

const MyCommitmentSection: React.FC<MyCommitmentSectionProps> = ({ data }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <section id="my-commitment" className="section-padding bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container-max">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={containerVariants}
          className="text-center mb-16"
        >
          <motion.h2 variants={itemVariants} className="text-4xl font-bold text-gray-900 mb-4">
            {data.title}
          </motion.h2>
          <motion.p variants={itemVariants} className="text-xl text-gray-600 max-w-3xl mx-auto text-left text-justify">
            {data.descriptionLine1}
            <br />
            <br />
            {data.descriptionLine2}
          </motion.p>
        </motion.div>
      </div>

      {/* Call to action */}
      <div className="container-max">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={containerVariants}
          className="text-center mt-16 p-8 bg-gradient-to-r from-edata-blue to-edata-light-blue rounded-2xl text-white"
        >
        <h3 className="text-2xl font-bold mb-4">Let's Connect</h3>
        <p className="text-lg mb-6 opacity-90">
          I am excited by the opportunity to help write the next chapter for Edata Consulting.
        </p>
        {/* use the data.contact to create the buttons */ }
        <div className="flex flex-col md:flex-row gap-4 justify-center">

        <a 
                href={data.contact.linkedin} 
                target="_blank" 
                rel="noopener noreferrer"
                className="group bg-gray-50 hover:bg-gray-100 p-6 rounded-xl transition-all duration-300 border border-gray-200 hover:border-gray-300"
              >
                <div className="text-center">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg mx-auto mb-4 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">LinkedIn</h3>
                  <p className="text-sm text-gray-600">Professional profile</p>
                </div>
              </a>

              <a 
                href={`mailto:${data.contact.email}`}
                className="group bg-gray-50 hover:bg-gray-100 p-6 rounded-xl transition-all duration-300 border border-gray-200 hover:border-gray-300"
              >
                <div className="text-center">
                  <div className="w-12 h-12 bg-red-500 rounded-lg mx-auto mb-4 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-.904.732-1.636 1.636-1.636h.682L12 13.5l9.682-9.68h.682A1.636 1.636 0 0 1 24 5.457z"/>
                    </svg>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">Email</h3>
                  <p className="text-sm text-gray-600">{data.contact.email}</p>
                </div>
              </a>
            
              </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MyCommitmentSection; 